import React from "react"
import { NumericFormat } from "react-number-format" // https://www.npmjs.com/package/react-number-format

const InputNumber = ({ fieldName, value, onChange, disabled, required, size }) => {
    const handleChange = (e) => {
        onChange({
            target: { name: fieldName, value: e.value },
        })
    }

    return (
        <NumericFormat
            name={fieldName}
            value={value}
            onValueChange={handleChange}
            className={!size ? "form-control" : "form-control form-control-"+size}
            thousandSeparator="."  // Usamos punto como separador de miles
            decimalSeparator=","    // Usamos coma como separador decimal
            //allowNegative={false}   // No permite números negativos
            decimalScale={2}        // Limita el número de decimales a 2
            fixedDecimalScale={true} // Siempre muestra 2 decimales
            placeholder="0.00"      // Placeholder del campo de entrada
            required={required}
            disabled={!!disabled}
            style={{ textAlign: "left" }}
        />
    )
}

export default InputNumber
